import React from 'react';

// The standalone document is also served directly in production, without React
// or authentication. Keep the policy in one place for both entry points.
const PrivacyPolicyAgronetPlus = ({ match }) => (
    <iframe
        title={match.path.endsWith('_pl') ? 'AgroNet Plus — Polityka prywatności' : 'AgroNet Plus Privacy Policy'}
        src={match.path.endsWith('_pl') ? '/privacy_policy_agronet_plus_pl.html' : '/privacy_policy_agronet_plus.html'}
        style={{ display: 'block', width: '100%', height: '100vh', border: 0 }}
    />
);

export default PrivacyPolicyAgronetPlus;
